import React from 'react';
import PropTypes from "prop-types";
import Paper from '../Paper';
import { makeStyles } from '../../utils/styles';
import Icon from '../Icon';
import Box from '../Box';

const useStyles = makeStyles(css => ({
    paper: css`
       padding: 20px;
       background-color: ${({ theme }) => theme.colors.purple};
       margin-bottom: 20px;
    `,
    box: css`
        display: flex;
    `,
    boxChildren: css`
        flex: 1;
        margin-left: 20px;
        color: ${({ theme }) => theme.colors.white};
    `
}));

const Banner = ({ children, customStyle }) => {
    const styles = useStyles();
    return (
        <Paper customStyle={[styles.paper, customStyle]}>
            <Box customStyle={styles.box}>
                <Icon name="info" width={30} height={30} />
                <Box customStyle={styles.boxChildren}>
                    {children}
                </Box>
            </Box>
        </Paper>
    );
};

Banner.propTypes = {
    children: PropTypes.node,
    customStyle: PropTypes.array
};

export default React.memo(Banner);
